/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useCallback, useState, useEffect } from "react";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { useHistory } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import PerfectScrollbar from "react-perfect-scrollbar";

import {
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  AppBar,
  Tab,
  LinearProgress,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import { TabContext, TabList } from "@material-ui/lab";

// @material-ui/icons components
import {
  Close as CloseIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@material-ui/icons";

import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { columnTextField, columnCNPJCPFField } from "utils/tables-utils";

import Api from "lib/api/httpRequestHelper";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const columnModel = [
  columnTextField(
    {
      dataField: "NomeLoja",
      text: "Loja",
      align: "center",
    },
    false
  ),
  columnTextField(
    {
      dataField: "DataInclusaoFormat",
      text: "Data criação",
      align: "center",
    },
    false
  ),
  columnTextField(
    {
      dataField: "IdPedido",
      text: "Número pedido",
      align: "center",
    },
    false
  ),
  columnTextField(
    {
      dataField: "NomeConsumidor",
      text: "Cliente",
      align: "center",
    },
    false
  ),
];

const columnModelExchanges = [
  columnTextField(
    {
      dataField: "NomeLoja",
      text: "Loja",
      align: "center",
    },
    false
  ),
  columnCNPJCPFField({
    dataField: "Cnpj",
    text: "CNPJ",
  }),
  columnTextField(
    {
      dataField: "DataInclusaoFormat",
      text: "Data Criação",
      align: "center",
    },
    false
  ),
  columnTextField(
    {
      dataField: "NomeConsumidor",
      text: "Cliente",
      align: "center",
    },
    false
  ),
  columnCNPJCPFField({
    dataField: "Cpf",
    text: "CPF Cliente",
  }),
];

const modelTableExchangeDetail = [
  columnTextField(
    {
      dataField: "IdPedido",
      text: "Pedido",
      align: "center",
    },
    false
  ),
  columnTextField(
    {
      dataField: "IdProduto",
      text: "Código Produto",
      align: "center",
    },
    false
  ),
  columnTextField(
    {
      dataField: "Tipo",
      text: "Tipo Solicitação",
      align: "center",
    },
    false
  ),
];

export default function DialogNotificationsCancelAndXML({
  onClose,
  hasNotificationCancel,
  hasNotificationPending,
  hasNotificationExchanges,
}) {
  const snackbar = useSnackbar();
  const history = useHistory();
  const classes = useStyles();
  const contentRef = useRef(null);
  const [valueTab, setValueTab] = useState("1");

  const [notificationsPendingList, setNotificationsPendingList] = useState([]);
  const [notificationsCancelList, setNotificationsCancelList] = useState([]);
  const [notificationsExchangesList, setNotificationsExchangesList] = useState(
    []
  );
  const [searchingCancel, setSearchingCancel] = useState(false);
  const [searchingPending, setSearchingPending] = useState(false);
  const [searchingExchanges, setSearchingExchanges] = useState(false);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleChangeTab = useCallback((event, newValue) => {
    setValueTab(newValue);
  }, []);

  const handleGetCancelNotifications = async () => {
    setSearchingCancel(true);

    await Api.get(
      "notification-detail-topic",
      "notification",
      "?idTopico=4",
      true
    )
      .then((res) => {
        if (res.Success) {
          setNotificationsCancelList(res?.Result);
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
      })
      .finally(() => {
        setSearchingCancel(false);
      });
  };

  const handleGetPendingNotifications = async () => {
    setSearchingPending(true);

    await Api.get(
      "notification-detail-topic",
      "notification",
      "?idTopico=1",
      true
    )
      .then((res) => {
        if (res.Success) {
          setNotificationsPendingList(res?.Result);
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
      })
      .finally(() => {
        setSearchingPending(false);
      });
  };

  const handleGetExchangesNotifications = async () => {
    setSearchingExchanges(true);

    await Api.get(
      "notification-detail-topic",
      "notification",
      "?idTopico=9",
      true
    )
      .then((res) => {
        if (res.Success) {
          const listItens = [];
          let newObject = {};

          if (res?.Result?.length !== 0) {
            res?.Result?.map((item) => {
              newObject = {
                Cnpj: item?.Cnpj,
                Cpf: item?.Cpf,
                DataInclusaoFormat: item?.DataInclusaoFormat,
                IdPessoa: item?.IdPessoa,
                NomeConsumidor: item?.NomeConsumidor,
                NomeLoja: item?.NomeLoja,
                ListaPedido: item?.ListaPedido,
                IdTroca: Math.floor(Math.random() * (100000 - 5000 + 1)) + 5000,
              };
              listItens?.push(newObject);
            });
            setNotificationsExchangesList(listItens);
          } else {
            setNotificationsExchangesList([]);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
      })
      .finally(() => {
        setSearchingExchanges(false);
      });
  };

  const handleSelectRow = (data, status) => {
    let url = "";

    if (status === "Cancelado") {
      url = `/admin/atendimentos-prateleira-infinita?idLoja=${data?.IdPessoa}&Status=Cancelado&numeroPedido=${data?.IdPedido}`;
      handleClose();
      return history.push(url);
    } else if (status === "Registrado") {
      url = `/admin/atendimentos-prateleira-infinita?idLoja=${data?.IdPessoa}&Status=Registrado&numeroPedido=${data?.IdPedido}`;
      handleClose();
      return history.push(url);
    } else {
      url = `/admin/trocas-devolucoes-prateleira-infinita?cpf=${data?.Cpf}`;
      handleClose();
      return history.push(url);
    }
  };

  const expandRow = {
    showExpandColumn: true,
    renderer: (row) => {
      const listItens = [];
      let newObject = {};

      if (row?.ListaPedido?.length !== 0) {
        row?.ListaPedido?.map((item) => {
          newObject = {
            IdPedido: item?.IdPedido,
            IdProduto: item?.IdProduto,
            Tipo: item?.Tipo,
            IdItem: Math.floor(Math.random() * (100000 - 5000 + 1)) + 5000,
          };
          listItens?.push(newObject);
        });
      }

      return (
        <Grid item xs={12}>
          <ToolkitProvider
            data={listItens}
            keyField={"IdItem"}
            columns={modelTableExchangeDetail}
          >
            {(props) => (
              <PerfectScrollbar>
                <BootstrapTable
                  {...props.baseProps}
                  bootstrap4={true}
                  bordered={false}
                  condensed={true}
                  striped={true}
                  hover={true}
                  style={{ overflow: "auto!important" }}
                />
              </PerfectScrollbar>
            )}
          </ToolkitProvider>
        </Grid>
      );
    },
    expandHeaderColumnRenderer: () => (
      <div
        style={{ cursor: "none" }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {" "}
      </div>
    ),
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <ExpandLessIcon />;
      }
      return <ExpandMoreIcon />;
    },
  };

  useEffect(() => {
    if (hasNotificationCancel) {
      handleGetCancelNotifications();
    }

    if (hasNotificationPending) {
      handleGetPendingNotifications();
    }

    if (hasNotificationExchanges) {
      handleGetExchangesNotifications();
    }
  }, [hasNotificationPending, hasNotificationCancel, hasNotificationExchanges]);

  return (
    <Dialog open onClose={handleClose} maxWidth="lg">
      <DialogTitle disableTypography id="alert-dialog-title">
        <Typography variant="h2" component="h2">
          Veja os pedidos de prateleira infinita cancelados, pendentes e/ou com
          troca/devolução.
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon fontSize="large" />
        </IconButton>
      </DialogTitle>
      <DialogContent ref={contentRef} style={{ padding: "0 1.5rem 1.5rem" }}>
        {notificationsCancelList?.length !== 0 ||
        notificationsPendingList?.length !== 0 ||
        notificationsExchangesList?.length !== 0 ? (
          <Grid container>
            <Grid
              item
              xs={12}
              style={{ marginBottom: "1rem", marginTop: "-1rem" }}
            >
              <TabContext value={valueTab}>
                <AppBar position="static" color="transparent">
                  <TabList
                    onChange={handleChangeTab}
                    variant={"scrollable"}
                    scrollButtons="on"
                    aria-label="scrollable auto tabs example"
                  >
                    <Tab
                      style={{ maxWidth: "max-content" }}
                      label="Cancelados"
                      value="1"
                      disabled={notificationsCancelList?.length === 0}
                    />
                    <Tab
                      style={{ maxWidth: "max-content" }}
                      label="Pendentes (sem XML)"
                      value="2"
                      disabled={notificationsPendingList?.length === 0}
                    />
                    <Tab
                      style={{ maxWidth: "max-content" }}
                      label="Trocas/Devoluções Pendentes (sem XML)"
                      value="3"
                      disabled={notificationsExchangesList?.length === 0}
                    />
                  </TabList>
                </AppBar>
              </TabContext>
            </Grid>
            <Grid item xs={12}>
              {valueTab === "1" && notificationsCancelList?.length !== 0 && (
                <ToolkitTable
                  searched={Boolean(notificationsCancelList)}
                  keyField="IdPedido"
                  dataTable={notificationsCancelList}
                  columnModel={columnModel}
                  onRowClick={(_, row) => handleSelectRow(row, "Cancelado")}
                  pagination={{
                    options: [10, 25, 50, 100],
                    defaultOption: 10,
                  }}
                  styledRow={{
                    cursor: "pointer",
                  }}
                  notFoundTitle="Não há pedidos cancelados."
                  notFoundSubtitle=""
                />
              )}
              {valueTab === "2" && notificationsPendingList?.length !== 0 && (
                <ToolkitTable
                  searched={Boolean(notificationsPendingList)}
                  keyField="IdPedido"
                  dataTable={notificationsPendingList}
                  columnModel={columnModel}
                  onRowClick={(_, row) => handleSelectRow(row, "Registrado")}
                  pagination={{
                    options: [10, 25, 50, 100],
                    defaultOption: 10,
                  }}
                  styledRow={{
                    cursor: "pointer",
                  }}
                  notFoundTitle="Não há pedidos pendentes."
                  notFoundSubtitle=""
                />
              )}
              {valueTab === "3" && notificationsExchangesList?.length !== 0 && (
                <ToolkitTable
                  searched={Boolean(notificationsExchangesList)}
                  keyField="IdTroca"
                  dataTable={notificationsExchangesList}
                  columnModel={columnModelExchanges}
                  onRowClick={(_, row) =>
                    handleSelectRow(row, "TrocaDevolucao")
                  }
                  pagination={{
                    options: [10, 25, 50, 100],
                    defaultOption: 10,
                  }}
                  styledRow={{
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                  bootstrapTableProps={{
                    expandRow,
                  }}
                  notFoundTitle="Não há trocas/devoluções."
                  notFoundSubtitle=""
                />
              )}
            </Grid>
          </Grid>
        ) : null}
      </DialogContent>
      {searchingCancel && (
        <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
          <span style={{ marginBottom: "0.5rem" }}>
            Buscando pedidos cancelados...
          </span>
          <LinearProgress />
        </Grid>
      )}
      {searchingPending && (
        <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
          <span style={{ marginBottom: "0.5rem" }}>
            Buscando pedidos pendentes...
          </span>
          <LinearProgress />
        </Grid>
      )}
      {searchingExchanges && (
        <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
          <span style={{ marginBottom: "0.5rem" }}>
            Buscando trocas/devoluções...
          </span>
          <LinearProgress />
        </Grid>
      )}
      {notificationsCancelList?.length === 0 &&
        notificationsPendingList?.length === 0 &&
        notificationsExchangesList?.length === 0 &&
        !searchingCancel &&
        !searchingPending &&
        !searchingExchanges && (
          <Grid
            container
            style={{ height: "100px", display: "flex", alignItems: "center" }}
          >
            <span style={{ paddingLeft: "50px", fontWeight: "600" }}>
              Não foram localizados pedidos.
            </span>
          </Grid>
        )}
    </Dialog>
  );
}
